
import React from 'react';
import AnimatedSection from './AnimatedSection.tsx';

const StatItem: React.FC<{ label: string; value: string; barWidth: string }> = ({ label, value, barWidth }) => (
  <div className="bg-gray-900/50 border border-neon-purple/30 p-4 rounded-lg backdrop-blur-sm">
    <div className="flex justify-between items-center mb-2">
      <h4 className="text-lg text-gray-300">{label}</h4>
      <span className="text-xl font-bold text-neon-cyan">{value}</span>
    </div>
    <div className="w-full bg-neon-purple/20 rounded-full h-2.5">
      <div
        className="bg-neon-cyan h-2.5 rounded-full neon-box"
        style={{ width: barWidth }}
      ></div>
    </div>
  </div>
);

const StatsBlock: React.FC = () => {
  return (
    <AnimatedSection className="w-full max-w-3xl">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-white">
        <StatItem label="Интеллект" value="99%" barWidth="99%" />
        <StatItem label="Скилл в играх" value="MAX" barWidth="100%" />
        <StatItem label="Удача" value="+1400%" barWidth="100%" />
      </div>
    </AnimatedSection>
  );
};

export default StatsBlock;
